import FilterList from "@mui/icons-material/FilterList";
import ViewColumn from "@mui/icons-material/ViewColumn";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

/**
 * Icon-only, so the label reaches screen readers — and Playwright's
 * `getByRole("button", { name })` — through `aria-label`.
 */
type ToolbarButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

/** The grid toolbar's Filters command. */
export const ToolbarFilterButton: React.FC<ToolbarButtonProps> = ({ onClick }) => (
  <Tooltip title="Filters">
    <IconButton size="medium" color="info" aria-label="Filters" onClick={onClick}>
      <FilterList />
    </IconButton>
  </Tooltip>
);

/** The grid toolbar's Manage Columns command. */
export const ToolbarManageColumnsButton: React.FC<ToolbarButtonProps> = ({ onClick }) => (
  <Tooltip title="Manage Columns">
    <IconButton size="medium" color="info" aria-label="Manage Columns" onClick={onClick}>
      <ViewColumn />
    </IconButton>
  </Tooltip>
);
